/**
 * Returns the net cost a facilitator pays to activate a member into a programme.
 *
 * For an approved sponsorship, the agreed amount is deducted from the member fee
 * (floored at 0). Pending sponsorships or no sponsorship = full fee.
 *
 * @param memberFee - The programme's per-member fee in ZAR.
 * @param sponsorship - The member's sponsorship, or null if none exists.
 */
export function effectiveMemberCost(
  memberFee: number,
  sponsorship: { status: string; agreedAmount: number } | null
): number {
  if (sponsorship?.status === "approved") {
    return Math.max(0, memberFee - sponsorship.agreedAmount);
  }
  return memberFee;
}
